import React, { useState, useEffect, useContext } from 'react'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DialogBox from '../../../shared/ui/DialogBox'
import InputField from '../../../shared/ui/InputField'
import Link from '../../../shared/ui/Link'
import Button from '../../../shared/ui/Button'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'


const styles = theme => ({
    
})

const RequestRevisionForm = ({ theme, classes, children, onClose, onConfirm, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  const [formData, setFormData] = useState({})

  let revision = []
  if (formData.revision_detail)
    revision = formData.revision_detail

  const revisionOptions = [
    {value: 'Price Change', text: 'Price Change'},
    {value: 'Trainer Change', text: 'Trainer Change'},
    {value: 'Others', text: 'Others'}
  ]

  const onChange = (fieldName) => (value) => {
    if (fieldName !== 'notes') {
      setFormData({
        ...formData,
        revision_detail:{
          ...revision,
          [fieldName]: value
        }
      })
    } else {
      let newFormData = {
        ...formData,
        [fieldName]: value
      }
      
      setFormData(newFormData)
    }
  }

  const confirmRevision = () => {
    if (!formData.revision_detail) {
      alert ("Please provide reason for request revision.")
      return
    }

    if (!formData.notes) {
      alert ("Please provide notes for request revision.")
      return
    }

    onConfirm(formData)
  }

  let revisionButtons = [
    <Button variant='contained' fullWidth onClick={onClose} color="default">
      Cancel
    </Button>,
    <Button variant='contained' fullWidth onClick={confirmRevision} color="primary">
      Confirm
    </Button>
  ]

  return (
    <DialogBox show={true} onClose={onClose} actionButtons={revisionButtons}>
      <Typography variant='body1'>
        What revision do you want to ask?
      </Typography>
      <Box className={classes.formControl} style={{width:'100%'}}>
        <InputField
          fieldName='price_change'
          type='checkbox'
          label={'Price Change'}
          value={revision.price_change}
          onChange={onChange('price_change')}
        />
        <InputField
          fieldName='trainer_change'
          type='checkbox'
          label={'Trainer Change'}
          value={revision.trainer_change}
          onChange={onChange('trainer_change')}
        />
        <InputField
          fieldName='others'
          type='checkbox'
          label={'Others'}
          value={revision.others}
          onChange={onChange('others')}
        />
        <InputField
          fieldName='notes'
          type='textarea'
          label='Please provide a detailed information for the revision'
          value={formData.notes}
          onChange={onChange('notes')}
        />
      </Box>
  </DialogBox>
  )
}

export default withStyles(styles, { withTheme: true })(
    (RequestRevisionForm)
)
